import { Row } from "@/components/Row";

import { cn } from "@/lib/utils";

// Ascending bar heights; higher filledCount = a "taller" difficulty read.
// Used for Job Difficulty in Dashboard
const BAR_HEIGHT_CLASS_NAMES = ["h-1.5", "h-2", "h-2.5", "h-3"];

export const LevelBarIndicator = ({
  activeClassName = "bg-slate-600",
  emptyClassName = "bg-slate-200",
  filledCount,
  maxBars = 4,
}: {
  activeClassName?: string;
  emptyClassName?: string;
  filledCount: number;
  maxBars?: number;
}) => {
  const render = () => (
    <Row className="items-end gap-0.5">
      {Array.from({ length: maxBars }, (_, index) => {
        const barNumber = index + 1;
        const isFilled = barNumber <= filledCount;

        return (
          <span
            key={barNumber}
            className={cn(
              "w-1 rounded-sm",
              BAR_HEIGHT_CLASS_NAMES[index] ?? "h-3",
              isFilled ? activeClassName : emptyClassName,
            )}
          />
        );
      })}
    </Row>
  );

  return render();
};
